import { useRouter } from '@edreamsodigeo/frontend-core';

export function useIsWebView() {
  const { query = {} } = useRouter();

  return (
    Boolean(query.interface) &&
    query.interface.toLowerCase().startsWith('native')
  );
}
